/**
 * Vertical configuration for ClawFarm multi-vertical platform
 */

import { Vertical } from "@/types/vertical";

export const VERTICAL_CONFIG: Record<string, Vertical> = {
  main: {
    id: "main",
    name: "ClawFarm",
    displayName: "ClawFarm",
    description: "Agent Platform for Professionals",
    domain: "clawfarm.ca",
    theme: { primaryColor: "#6366f1" },
    terminology: { agent: "Agent" },
    enabledFeatures: ["agents", "billing", "skills"],
    isActive: true,
    navigation: ["dashboard", "agents", "billing", "skills", "settings"],
  },
};

/**
 * Get vertical by domain name
 * Handles subdomains by checking if the domain ends with a known vertical domain
 * Checks for longest match first to handle subdomains correctly
 */
export function getVerticalByDomain(hostname: string): Vertical {
  // Sort verticals by domain length (longest first) for most specific match
  const sortedVerticals = Object.values(VERTICAL_CONFIG).sort(
    (a, b) => b.domain.length - a.domain.length
  );

  // Check for exact match first
  for (const vertical of sortedVerticals) {
    if (vertical.domain === hostname) {
      return vertical;
    }
  }

  // Check for subdomain match (e.g., www.vertical.clawfarm.ca should match its vertical)
  for (const vertical of sortedVerticals) {
    if (hostname.endsWith(`.${vertical.domain}`)) {
      return vertical;
    }
  }

  // Fallback to main
  return VERTICAL_CONFIG.main;
}

/**
 * Get vertical by ID
 */
export function getVerticalById(id: string): Vertical | undefined {
  return VERTICAL_CONFIG[id];
}

/**
 * Get all active verticals
 */
export function getAllActiveVerticals(): Vertical[] {
  return Object.values(VERTICAL_CONFIG).filter((v) => v.isActive);
}
